import _ from 'lodash';
import { log } from '@swiper/core';
import config from '~/config';

export default function createStationIdHook( opts={} ) {
  return function stationIdHook( context ) {
    // context properties
    //    app         The feathers app (readonly)
    //    service     The service (readonly)
    //    path        Service path (readonly)
    //    method      Service method (readonly)
    //    type        Hook type (before/after/error) (readonly)
    //    params      Service method parameters
    //    id          Resource id for get/remove/update/patch
    //    data        Resource data for create/update/patch
    //    error       Error instance (if type==='error')
    //    result      The result of the method call
    //    dispatch    "Safe" version of the data to send to client
    //    statusCode  HTTP status code
    const { type, service, method, params } = context;
    const label = [ service.name, type, method ].join( '.' );
    const id = _.get( params, 'payload.stationId' );
    log.debug( `[STATION_ID] ${label}` );
    return;
  };
}
